/**
 * ArtifactEditForm — edit mode for an artifact. Demo page: /form-layouts (sectioned form).
 * Generated `zArtifactUpdate`; the server's limits apply (title 1–200, content required).
 */
import React from 'react';
import {
  Form,
  FormActions,
  FormFullWidth,
  FormSection,
  SelectFormField,
  TextAreaFormField,
  TextFormField,
  useZodForm,
} from '../../../components/form/index.js';
import { Card } from '../../../components/ui/index.js';
import { zArtifactUpdate } from '../../../generated/api/zod.gen.js';
import { ARTIFACT_KINDS, getKindConfig, type ArtifactKind } from './kind-config.js';

const editSchema = zArtifactUpdate.required({ title: true, content: true, kind: true });

interface ArtifactEditFormProps {
  initial: { title: string; content: string; kind: ArtifactKind };
  onCancel: () => void;
  /** Throws on failure so the form places the server's message. */
  onSave: (values: { title: string; content: string; kind: ArtifactKind }) => Promise<unknown>;
}

export const ArtifactEditForm: React.FC<ArtifactEditFormProps> = ({ initial, onCancel, onSave }) => {
  const form = useZodForm(editSchema, { defaultValues: initial });
  return (
    <Card>
      <Form form={form} onSubmit={onSave} guardUnsaved>
        <FormSection title="Edit artifact">
          <TextFormField name="title" label="Title" required />
          <SelectFormField
            name="kind"
            label="Type"
            required
            options={ARTIFACT_KINDS.map((k) => ({ value: k, label: getKindConfig(k).badgeLabel }))}
          />
          <FormFullWidth>
            <TextAreaFormField name="content" label="Content" required rows={20} description="Markdown is supported." />
          </FormFullWidth>
        </FormSection>
        <FormActions submitLabel="Save changes" onCancel={onCancel} />
      </Form>
    </Card>
  );
};
